/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { Row, Column } from '../../../styles/Grid';
import { Icon } from '../../ui/Icon';
import Picture from '../../ui/Picture';
import { formatStringToId } from '../../../utils/stringToId';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  imageWrapper,
  arrowBtnCss,
  arrowCss,
  arrowLeftCss,
  buttonsWrapperCss,
  imageCaptionCss,
  captionControlsCss,
  activeImageCss,
  inactiveImageCss,
  leftButtonCss,
} from './index.styles';

const getImagesList = images => {
  if (!images || images.length === 0) return [];
  const itemsCount = images.length - 1;
  return images.map((image, i) => {
    image.active = false;
    if (i === itemsCount && i !== 0) {
      image.next = 0;
      image.prev = i - 1;
    } else if (i === 0) {
      image.next = i + 1;
      image.prev = itemsCount;
      image.active = true;
    } else {
      image.next = i + 1;
      image.prev = i - 1;
    }
    return image;
  });
};

class GalleryCarousel extends SafePureComponent {
  constructor(props) {
    super(props);
    this.imageList = getImagesList(props.images);
    this.hasImages = this.imageList.length > 0;
    this.state = {
      galery: this.imageList,
      renderControls: this.imageList.length > 1,
      currentImage: this.hasImages ? this.imageList[0] : null,
      prevImage: this.hasImages ? this.imageList[0].prev : null,
      nextImage: this.hasImages ? this.imageList[0].next : null,
    };
  }

  changeImage = newActiveIndex => {
    let currentImage = null;
    const galery = this.state.galery.map((image, i) => {
      if (i === newActiveIndex) {
        image.active = true;
        currentImage = image;
      } else {
        image.active = false;
      }
      return image;
    });
    this.setState({
      prevImage: currentImage.prev,
      nextImage: currentImage.next,
      currentImage,
      galery,
    });
  };

  renderButtons = (prevImage, nextImage) => {
    return (
      <div css={buttonsWrapperCss}>
        <button
          css={[arrowBtnCss, leftButtonCss]}
          name="Previous image"
          aria-label="Previous image"
          onClick={() => this.changeImage(prevImage)}
        >
          <Icon customCss={[arrowCss, arrowLeftCss]} name="arrow-left" />
        </button>
        <button
          css={arrowBtnCss}
          name="Next image"
          aria-label="Next image"
          onClick={() => this.changeImage(nextImage)}
        >
          <Icon customCss={arrowCss} name="arrow-right" />
        </button>
      </div>
    );
  };

  renderImage = (image, imageSizes) => {
    return (
      <div
        key={formatStringToId(image.value.caption)}
        css={[imageWrapper, image.active ? activeImageCss : inactiveImageCss]}
      >
        <Picture image={image} imageSizes={imageSizes} />
      </div>
    );
  };

  safeRender() {
    const { imageSizes } = this.props;
    const {
      renderControls,
      currentImage,
      galery,
      prevImage,
      nextImage,
    } = this.state;
    if (currentImage && currentImage.value) {
      return (
        <div>
          {galery.map(image =>
            this.renderImage(image, imageSizes, renderControls),
          )}
          <Row css={captionControlsCss}>
            <Column cols={{ md: [3, 4], lg: [3, 4] }}>
              <p css={imageCaptionCss}>{currentImage.value.caption}</p>
            </Column>
            {renderControls && this.renderButtons(prevImage, nextImage)}
          </Row>
        </div>
      );
    }
    return null;
  }
}

GalleryCarousel.displayName = 'GalleryCarousel';

GalleryCarousel.propTypes = {
  Images: PropTypes.arrayOf(
    PropTypes.shape({
      Image: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
        caption: PropTypes.string,
      }),
    }),
  ),
  imageSizes: PropTypes.object,
};

export default GalleryCarousel;
